import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { AddInput, Workflow } from '../../../shared/domain/workflows/types.no-deps'
import type { ReportStatus } from '../../../shared/domain/reportStatus/types.no-deps'
import type { DatabaseWorkflowElementTag, WorkflowChoiceTag } from '../../../shared/domain/tags/types.no-deps'
import type { ReportStatusFlow } from '../../../shared/domain/reportStatusFlow/types.no-deps'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import type { WorkflowParameter } from '../../../shared/domain/workflowParameter/types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/procedures/:procedure/workflows' }

type Params = { procedure: number }
type Body = AddInput
type Query = never
export interface AddWorkflowOutput {
    workflow: Workflow
    reportStatuses: Array<Omit<ReportStatus, 'workflowId'> & { workflow: number }>
    reportStatusFlow?: Nullable<ReportStatusFlow>
    tags?: string[]
    elementTags?: DatabaseWorkflowElementTag[]
    choiceTags?: WorkflowChoiceTag[]
    trainingRecommendations: number[]
    workflowParameters?: WorkflowParameter[]
}

export type AddEndpoint = Endpoint<Params, Body, Query, AddWorkflowOutput>

export const addRequest = (request: Request, args: RequestArgs<AddEndpoint>) => request<AddEndpoint>(route, args)
